import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { NewKeyresultDialogComponent } from '../../components/new-keyresult-dialog/new-keyresult-dialog.component';
import { NewTaskDialogComponent } from '../../components/new-task-dialog/new-task-dialog.component';
import { UpdateTaskDialogComponent } from '../../components/update-task-dialog/update-task-dialog.component';
import { Objective } from '../../models/objectives';
import { ObjectivesService } from '../../services/objectives.service';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/divider';
import { DatePipe } from '@angular/common';
import { ObjectiveStatusDivComponent } from '../../components/objective-status-div/objective-status-div.component';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatButton } from '@angular/material/button';
import { KeyresultStatusRowComponent } from '../../components/keyresult-status-row/keyresult-status-row.component';
import { TaskStatusRowComponent } from '../../components/task-status-row/task-status-row.component';
import { ObjectivePlayerRowComponent } from '../../components/objective-player-row/objective-player-row.component';
import { CheckinViewCardComponent } from '../../components/checkin-view-card/checkin-view-card.component';

@Component({
    selector: 'app-objective-details',
    templateUrl: './objective-details.component.html',
    styleUrls: ['./objective-details.component.css'],
    imports: [MatIcon, MatDivider, ObjectiveStatusDivComponent, MatProgressBar, MatButton, KeyresultStatusRowComponent, TaskStatusRowComponent, ObjectivePlayerRowComponent, RouterLink, CheckinViewCardComponent, DatePipe]
})
export class ObjectiveDetailsComponent implements OnInit {  
  Objective: Objective;
  ObjectiveId: string;
  
  constructor(
    private objectiveService: ObjectivesService,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    private router: Router
  ) { }

  ngOnInit(): void {

    this.activatedRoute.params.subscribe(params => {
      
      this.ObjectiveId = params['ObjectiveId'];      
      this.objectiveService.getObjective(this.ObjectiveId).subscribe(data=>{
        this.Objective = data;
      });
      
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    


    });
  }



  addKeyResult(){
    const newObjectiveDialog = this.dialog.open(NewKeyresultDialogComponent, {
      data: {
       ObjectiveId: this.ObjectiveId,
       Owner: this.Objective.Owner
      }
    });
    newObjectiveDialog.afterClosed().subscribe(result => {
      this.objectiveService.getObjective(this.ObjectiveId).subscribe(data=>{
        this.Objective = data;
      });
    });
  }

  addTask(){
    const newObjectiveDialog = this.dialog.open(NewTaskDialogComponent, {
      data: {
       ObjectiveId: this.ObjectiveId,
       Owner: this.Objective.Owner
      }
    });
    newObjectiveDialog.afterClosed().subscribe(result => {
      this.objectiveService.getObjective(this.ObjectiveId).subscribe(data=>{
        this.Objective = data;
      });
    });
  }

  removeKeyResult(KeyResultId: number): void{
    this.objectiveService.getObjective(this.ObjectiveId).subscribe(data=>{
      this.Objective = data;
    });

  }

  refreshTasks(): void{
    this.objectiveService.getObjective(this.ObjectiveId).subscribe(data=>{
      this.Objective = data;
    });

  }

  refreshCheckins(): void{
    this.objectiveService.getObjective(this.ObjectiveId).subscribe(data=>{
      this.Objective = data;
    });

  }

  refreshKeyResult(KeyResultId: number): void{
    this.objectiveService.getObjective(this.ObjectiveId).subscribe(data=>{
      this.Objective = data;
    });

  }

  
  

}
